import React from 'react'

import { isEmpty } from 'lodash'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { Box, Hidden, Paper, TablePagination } from '@material-ui/core'

import { LoadingFeedback, NoData2 } from 'components'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'

import { ActionButtons } from './components'

import constants from 'constants/index'
import helpers from 'helpers'
import * as service from 'service'

import useFetch from 'hooks/useFetch'
import usePagination from 'hooks/usePagination'

const NcTable = () => {
  const { PRIORITIES } = constants.monitoringManagementNc

  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(10)

  const { response, isLoading, refresh } = useFetch(
    service.dponet.monitoringManagementNc.list,
    { perPage, page },
    [perPage, page],
  )

  const monitoringManagementNcs = response?.data?.monitoringManagementNcs

  return (
    <>
      <LoadingFeedback open={isLoading} />
      <Paper>
        {!isEmpty(monitoringManagementNcs) ? (
          <>
            <Box width="100%">
              <PerfectScrollbar
                options={{ wheelPropagation: false, useBothWheelAxes: true }}
              >
                <Table size="small" noWrap>
                  <TableHead>
                    <TableRow>
                      <TableCell>ID</TableCell>
                      <TableCell>Título</TableCell>
                      <TableCell>Responsável</TableCell>
                      <TableCell>Prioridade</TableCell>
                      <TableCell>Data da Ocorrência</TableCell>
                      <TableCell align="right">Ações</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {monitoringManagementNcs?.map((monitoringManagementNc) => (
                      <TableRow key={monitoringManagementNc?.id}>
                        <TableCell>{monitoringManagementNc?.id}</TableCell>
                        <TableCell>{monitoringManagementNc?.title}</TableCell>
                        <TableCell>
                          {monitoringManagementNc?.responsible?.name}
                        </TableCell>
                        <TableCell>
                          {PRIORITIES[monitoringManagementNc?.priority] || '-'}
                        </TableCell>
                        <TableCell>
                          {helpers.formatters.date(
                            monitoringManagementNc?.occurrenceDate,
                          ) || '-'}
                        </TableCell>
                        <TableCell align="right">
                          <ActionButtons
                            monitoringManagementNc={monitoringManagementNc}
                            refresh={refresh}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </PerfectScrollbar>
            </Box>
            <TablePagination
              component="div"
              count={response?.data?.meta?.totalCount || 0}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              page={page - 1}
              rowsPerPage={perPage}
              rowsPerPageOptions={[5, 10, 25, 100]}
              labelRowsPerPage={<Hidden smDown>Por página</Hidden>}
              nextIconButtonProps={{ size: 'small' }}
              backIconButtonProps={{ size: 'small' }}
            />
          </>
        ) : (
          !isLoading && <NoData2 title="Nenhuma Não Conformidade encontrada." />
        )}
      </Paper>
    </>
  )
}

export default NcTable
